/**
 * create by zpf 2018-08-01
 * 项目启动页
 */
import React from 'react'
import { render } from 'react-dom'
import { HashRouter } from 'react-router-dom'
import { Provider } from 'mobx-react'
import AppLoader from './appLoader'
import appModel from './model/appModel'
import config from './model/configModel'
import { UserStore, RouterStore, UIStore } from './store'

export default function start () {
  const currentConfig = config.getOption()

  appModel.registerApps(currentConfig.apps)

  render(
    <Provider UserStore={UserStore} RouterStore={RouterStore} UIStore={UIStore}>
      <HashRouter>
        <AppLoader appName={currentConfig.startAppName}/>
      </HashRouter>
    </Provider>,
    document.getElementById(currentConfig.targetDomId)
  )
}



// WEBPACK FOOTER //
// ./src/wbap-core-commit/start.js